/* LXRYWOOD Produktdetails: Akkordeon / Reiter, Querschnitt-Hervorhebung, Akustik-Wähler.
   Keine Abhängigkeiten. Initialisierung pro Block erst in Viewport-Nähe (IntersectionObserver).
   Die rAF-Schleife läuft nur, solange ein Akustik-Bereich geöffnet UND sichtbar ist. */
(function () {
  'use strict';
  if (window.LxryPd) { window.LxryPd.scan(); return; }

  var EASE = 'cubic-bezier(.2,.7,.2,1)';
  var X0 = 30, X1 = 540, Y = 95, AMP = 70;
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reg = new WeakMap();
  var list = [];
  var running = [];
  var raf = 0, lastT = 0;
  var lazy = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (en) {
      if (!en.isIntersecting) return;
      lazy.unobserve(en.target);
      var p = reg.get(en.target);
      if (p) p.init(false);
    });
  }, { rootMargin: '600px 0px' }) : null;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* Höhenanimation (Web Animations API); ohne Animation sofort */
  function slide(p, on, anim) {
    if (!anim || !p.animate) { p.hidden = !on; return; }
    if (p._a) p._a.cancel();
    if (on) {
      p.hidden = false;
      var h = p.scrollHeight;
      p._a = p.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 320, easing: EASE });
    } else {
      var h2 = p.offsetHeight;
      var a = p._a = p.animate([{ height: h2 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 260, easing: EASE, fill: 'forwards' });
      a.onfinish = function () { p.hidden = true; a.cancel(); };
    }
  }

  /* Nachklang-Kurve: Welle + Hüllkurve in einer Schleife, 4-px-Raster */
  function curves(k, ph) {
    var d = '', t = '', b = '', x, u, e;
    for (x = X0; x <= X1; x += 4) {
      u = (x - X0) / (X1 - X0);
      e = Math.exp(-k * u) * AMP;
      d += (x === X0 ? 'M' : 'L') + x + ' ' + (Y - e * Math.sin(u * 62 - ph)).toFixed(1);
      t += (x === X0 ? 'M' : 'L') + x + ' ' + (Y - e).toFixed(1);
      b = 'L' + x + ' ' + (Y + e).toFixed(1) + b;
    }
    return [d, t + b + 'Z'];
  }

  function tick(t) {
    raf = 0;
    if (!running.length) return;
    if (t - lastT >= 32) {
      lastT = t;
      running.forEach(function (p) { p.cur += (p.a - p.cur) * 0.07; p.draw(t); });
    }
    raf = requestAnimationFrame(tick);
  }

  function Pd(root) {
    var self = this;
    this.root = root;
    this.mode = root.dataset.mode;
    this.sw = +root.dataset.switch || 520;
    this.multi = root.dataset.multi === 'true';
    this.firstOpen = root.dataset.firstOpen !== 'false';
    this.single = root.dataset.single === 'true';
    this.anim = root.dataset.anim !== 'false';
    this.speed = (+root.dataset.speed || 100) / 100;
    this.view = root.dataset.view;
    this.secs = $$('.lxry-pd__sec', root).map(function (el, i) {
      var panel = $('.lxry-pd__panel', el);
      var acc = $('.lxry-pd__acc', el);
      var tab = $('[role="tab"][aria-controls="' + panel.id + '"]', root);
      acc._i = i; tab._i = i;
      return { key: el.dataset.sec, panel: panel, acc: acc, tab: tab };
    });
    this.tabsEl = $('.lxry-pd__tabs', root);
    this.ind = $('.lxry-pd__ind', root);
    this.tr = [];
    this.ready = false;
    this.vis = false;
    this.a = 0.8; this.cur = 0.8;
    // Interaktion vor der Initialisierung (Tastatur, Touch) löst sie sofort aus
    var early = function () { root.removeEventListener('pointerdown', early); root.removeEventListener('focusin', early); self.init(true); };
    root.addEventListener('pointerdown', early, { passive: true });
    root.addEventListener('focusin', early);
  }

  Pd.prototype.animOn = function () { return this.anim && !rm.matches; };

  Pd.prototype.init = function (user) {
    if (this.ready) return;
    this.ready = true;
    var self = this, r = this.root;
    this.hov = window.matchMedia('(hover:hover)').matches;
    this.open = this.secs.map(function (s) { return !s.panel.hidden; });
    this.last = Math.max(this.open.indexOf(true), 0);

    r.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('.lxry-pd__acc, .lxry-pd__tab, .lxry-pd__radio, .lxry-pd__part') : null;
      if (!t) return;
      if (t.classList.contains('lxry-pd__acc')) self.toggle(t._i);
      else if (t.classList.contains('lxry-pd__tab')) self.select(t._i, false);
      else if (t.classList.contains('lxry-pd__radio')) self.pick(t);
      else self.part(t, true);
    });
    r.addEventListener('keydown', function (e) {
      var t = e.target.closest ? e.target.closest('.lxry-pd__tab, .lxry-pd__radio') : null;
      if (!t) return;
      var isTab = t.classList.contains('lxry-pd__tab');
      var set = isTab ? self.secs.map(function (s) { return s.tab; }) : $$('.lxry-pd__radio', t.parentNode);
      var i = set.indexOf(t), n = null, k = e.key;
      if (k === 'ArrowRight' || (!isTab && k === 'ArrowDown')) n = set[(i + 1) % set.length];
      else if (k === 'ArrowLeft' || (!isTab && k === 'ArrowUp')) n = set[(i - 1 + set.length) % set.length];
      else if (isTab && k === 'Home') n = set[0];
      else if (isTab && k === 'End') n = set[set.length - 1];
      if (!n) return;
      e.preventDefault();
      if (isTab) self.select(n._i, true); else { self.pick(n); n.focus(); }
    });
    if (this.hov) {
      r.addEventListener('mouseover', function (e) {
        var b = e.target.closest ? e.target.closest('.lxry-pd__part') : null;
        if (b) self.part(b, false);
      });
      $$('.lxry-pd__specs', r).forEach(function (u) {
        u.addEventListener('mouseleave', function () { self.part(u, false, true); });
      });
    }

    // Akustik
    var ai = this.secs.map(function (s) { return s.key; }).indexOf('akustik');
    if (ai > -1) {
      this.ai = ai;
      var ak = this.akEl = $('[data-ak]', this.secs[ai].panel);
      this.dw = $('.d-wave', ak); this.de = $('.d-env', ak); this.dr = $('.d-ref', ak);
      var chk = $('.lxry-pd__radio[aria-checked="true"]', ak) || $('.lxry-pd__radio', ak);
      if (chk) this.pick(chk);
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (es) {
          self.vis = es[es.length - 1].isIntersecting;
          self.sync();
        });
        this.io.observe($('.lxry-pd__wave', ak));
      }
    }

    // Breite des Blocks entscheidet über Akkordeon oder Reiter (gleiche Schwelle wie die CSS-Container-Query)
    var first = true;
    if (this.mode !== 'akkordeon' && window.ResizeObserver) {
      this.ro = new ResizeObserver(function (es) {
        var w = es[0].contentRect.width;
        if (!w) return;
        var v = self.mode === 'reiter' ? 'tabs' : (w >= self.sw ? 'tabs' : 'acc');
        self.setView(v);
        if (first && !user && v === 'acc' && !self.firstOpen && !self.single) { self.open = self.open.map(function () { return false; }); self.apply(); }
        first = false;
        if (self.view === 'tabs') { self.measure(); self.move(); }
      });
      this.ro.observe(r);
    }
    this.apply();
  };

  /* Zustand (open[], last, view) -> DOM */
  Pd.prototype.apply = function () {
    var self = this, tabs = this.view === 'tabs';
    this.secs.forEach(function (s, i) {
      var on = tabs ? i === self.last : !!self.open[i];
      s.panel.hidden = !on;
      s.panel.setAttribute('role', tabs ? 'tabpanel' : 'region');
      s.panel.setAttribute('aria-labelledby', (tabs ? s.tab : s.acc).id);
      s.acc.setAttribute('aria-expanded', on ? 'true' : 'false');
      s.tab.setAttribute('aria-selected', i === self.last ? 'true' : 'false');
      s.tab.tabIndex = i === self.last ? 0 : -1;
    });
    this.root.dataset.view = this.view;
    this.sync();
  };

  Pd.prototype.setView = function (v) {
    if (this.view === v) return;
    this.view = v;
    // Der zuletzt aktive Bereich bleibt aktiv
    this.open = this.secs.map(function (s, i) { return i === this.last; }, this);
    this.apply();
  };

  Pd.prototype.toggle = function (i) {
    var self = this, on = !this.open[i];
    if (on && !this.multi) {
      this.secs.forEach(function (s, j) {
        if (j !== i && self.open[j]) { self.open[j] = false; s.acc.setAttribute('aria-expanded', 'false'); slide(s.panel, false, self.animOn()); }
      });
    }
    this.open[i] = on;
    if (on) this.last = i;
    this.secs[i].acc.setAttribute('aria-expanded', on ? 'true' : 'false');
    slide(this.secs[i].panel, on, this.animOn());
    this.sync();
  };

  Pd.prototype.select = function (i, focus) {
    var self = this;
    this.last = i;
    this.open = this.secs.map(function (s, j) { return j === i; });
    this.secs.forEach(function (s, j) {
      var on = j === i;
      s.tab.setAttribute('aria-selected', on ? 'true' : 'false');
      s.tab.tabIndex = on ? 0 : -1;
      s.panel.hidden = !on;
      s.acc.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    var t = this.secs[i].tab;
    if (focus) t.focus();
    if (t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: self.animOn() ? 'smooth' : 'auto' });
    this.move();
    this.sync();
  };

  /* Tab-Positionen werden nur beim Resize gemessen; das Verschieben des Indikators liest nichts */
  Pd.prototype.measure = function () {
    this.tr = this.secs.map(function (s) { return [s.tab.offsetLeft + 12, s.tab.offsetWidth - 24]; });
  };
  Pd.prototype.move = function () {
    var p = this.tr[this.last];
    if (!p) return;
    this.ind.style.setProperty('--ix', p[0] + 'px');
    this.ind.style.setProperty('--iw', p[1] + 'px');
  };

  /* Querschnitt <-> Maßliste */
  Pd.prototype.part = function (b, click, leave) {
    var wrap = b.closest('[data-xs]');
    if (!wrap) return;
    var svg = $('[data-xsvg]', wrap), btns = $$('.lxry-pd__part', wrap);
    var p = leave ? null : b.dataset.part;
    if (click && !this.hov && b.getAttribute('aria-pressed') === 'true') p = null;
    if (svg) {
      svg.classList.toggle('is-focus', !!p);
      $$('[data-part]', svg).forEach(function (el) {
        el.classList.toggle('hl', !!p && (' ' + el.getAttribute('data-part') + ' ').indexOf(' ' + p + ' ') > -1);
      });
    }
    btns.forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.part === p ? 'true' : 'false'); });
  };

  /* Montageart */
  Pd.prototype.pick = function (b) {
    var ak = b.closest('[data-ak]');
    $$('.lxry-pd__radio', b.parentNode).forEach(function (x) {
      x.setAttribute('aria-checked', x === b ? 'true' : 'false');
      x.tabIndex = x === b ? 0 : -1;
    });
    $$('[data-what]', ak).forEach(function (p) { p.hidden = p.dataset.what !== b.dataset.m; });
    $('[data-alpha]', ak).textContent = b.dataset.a;
    $('[data-mlabel]', ak).textContent = b.dataset.name;
    $$('.lxry-pd__scale span', ak).forEach(function (s) {
      var on = s.textContent === b.dataset.c;
      s.classList.toggle('on', on);
      if (on) s.setAttribute('aria-current', 'true'); else s.removeAttribute('aria-current');
    });
    this.a = (+b.dataset.ai) / 100;
    if (running.indexOf(this) < 0) { this.cur = this.a; this.draw(2600); }
  };

  Pd.prototype.draw = function (t) {
    if (!this.dw) return;
    var ph = (t / 1000) * 4 * this.speed;
    var c = curves(1.4 + this.cur * 6.2, ph);
    this.dw.setAttribute('d', c[0]);
    this.de.setAttribute('d', c[1]);
    this.dr.setAttribute('d', curves(0.9, ph)[0]);
  };

  /* Schleife nur, wenn Akustik geöffnet, sichtbar und Animation erlaubt */
  Pd.prototype.sync = function () {
    if (this.ai === undefined) return;
    var tabs = this.view === 'tabs';
    var shown = tabs ? this.last === this.ai : !!this.open[this.ai];
    var on = this.animOn() && this.vis && shown;
    var i = running.indexOf(this);
    if (on && i < 0) {
      running.push(this);
      if (!raf) raf = requestAnimationFrame(tick);
    } else if (!on && i > -1) {
      running.splice(i, 1);
      this.cur = this.a;
      this.draw(2600);
    }
  };

  Pd.prototype.destroy = function () {
    var i = running.indexOf(this);
    if (i > -1) running.splice(i, 1);
    if (this.ro) this.ro.disconnect();
    if (this.io) this.io.disconnect();
    if (lazy) lazy.unobserve(this.root);
  };

  function scan() {
    list = list.filter(function (p) {
      if (p.root.isConnected) return true;
      p.destroy();
      return false;
    });
    $$('[data-lxry-pd]').forEach(function (el) {
      if (reg.has(el)) return;
      var p = new Pd(el);
      reg.set(el, p);
      list.push(p);
      if (lazy) lazy.observe(el); else p.init(false);
    });
  }

  rm.addEventListener && rm.addEventListener('change', function () { list.forEach(function (p) { if (p.ready) p.sync(); }); });

  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', scan);
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target && e.target.querySelector ? (e.target.matches('[data-lxry-pd]') ? e.target : e.target.querySelector('[data-lxry-pd]')) : null;
    var p = el && reg.get(el);
    if (!p) return;
    p.init(true);
    if (p.view === 'acc' && !p.open.some(Boolean)) p.toggle(p.last);
  });

  window.LxryPd = { scan: scan };
  scan();
})();
